import { render, staticRenderFns } from "./StateBadge.vue?vue&type=template&id=bc08cbe6&"
import script from "./StateBadge.vue?vue&type=script&lang=js&"
export * from "./StateBadge.vue?vue&type=script&lang=js&"
import style0 from "./StateBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports